export const HOME = '/';
export const NOT_FOUND = '/404';
export const HELP = '/help';
export const ERROR = '/error';